import { QUESTIONNAIRE } from "@/lib/questionnaire";
import { inputCls } from "@/components/common";

const Chip = ({ active, onClick, children, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`rounded-full border px-3.5 py-1.5 text-sm transition-colors duration-200 ${active ? "border-[#C5A059] bg-[#121212] text-[#F6F1EA]" : "border-[#E8E1D7] bg-white text-[#24211E] hover:border-[#C5A059]"}`}>
    {children}
  </button>
);

const Question = ({ q, value, onChange }) => {
  if (q.type === "text") return <input className={inputCls} placeholder={q.placeholder} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`q-${q.key}`} />;
  if (q.type === "textarea") return <textarea rows={3} className={inputCls} placeholder={q.placeholder} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`q-${q.key}`} />;
  const multi = q.type === "multi";
  const arr = Array.isArray(value) ? value : [];
  const toggle = (o) => (multi ? onChange(arr.includes(o) ? arr.filter((x) => x !== o) : [...arr, o]) : onChange(value === o ? "" : o));
  return (
    <div className="flex flex-wrap gap-2">
      {q.options.map((o, i) => (
        <Chip key={o} active={multi ? arr.includes(o) : value === o} onClick={() => toggle(o)} testId={`q-${q.key}-opt-${i}`}>{o}</Chip>
      ))}
    </div>
  );
};

export const QuestionnaireForm = ({ value, onChange, sections = QUESTIONNAIRE }) => (
  <div className="space-y-10">
    {sections.map((s) => (
      <section key={s.title}>
        <h3 className="font-serif text-2xl text-[#121212] mb-5 flex items-center gap-3">
          <span className="h-px w-8 bg-[#C5A059]" />{s.title}
        </h3>
        <div className="space-y-6">
          {s.questions.map((q) => (
            <div key={q.key}>
              <div className="mb-2 text-sm font-medium text-[#24211E]">{q.label}</div>
              <Question q={q} value={value[q.key]} onChange={(v) => onChange({ ...value, [q.key]: v })} />
            </div>
          ))}
        </div>
      </section>
    ))}
  </div>
);

export const QuestionnaireView = ({ value = {} }) => (
  <div className="space-y-8">
    {QUESTIONNAIRE.map((s) => (
      <section key={s.title}>
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#C5A059] mb-3">{s.title}</div>
        <dl className="divide-y divide-[#E8E1D7]">
          {s.questions.map((q) => {
            const v = value[q.key];
            const txt = Array.isArray(v) ? v.join(", ") : v;
            return (
              <div key={q.key} className="grid gap-1 py-3 sm:grid-cols-2 sm:gap-6">
                <dt className="text-sm text-[#6E675F]">{q.label}</dt>
                <dd className="text-sm text-[#121212]" data-testid={`qv-${q.key}`}>{txt || <span className="text-[#9E958A]">—</span>}</dd>
              </div>
            );
          })}
        </dl>
      </section>
    ))}
  </div>
);
